import { useState, useEffect, Dispatch, SetStateAction } from 'react'

const prefix = 'msbcc_'

function getSavedValue<T>(key: string, initialValue?: T, isJson: boolean = true): T {
  const result = localStorage.getItem(key) || null
  if (result !== null) {
    let savedValue = (isJson) ? JSON.parse(result) || 'undefined' : result
    if (typeof savedValue !== 'undefined' && savedValue !== null) {
      return savedValue
    }
  }

  if (initialValue instanceof Function) return initialValue() as T
  return initialValue as T
}

export default function useLocalStorage<T = any>(key: string, initialValue?: T, isJson: boolean = true): [T, Dispatch<SetStateAction<T>>] {
  const theKey = prefix + key
  const [value, setValue] = useState<T>(() => {
    return getSavedValue<T>(theKey, initialValue, isJson)
  })

  useEffect(() => {
    if (isJson) localStorage.setItem(theKey, JSON.stringify(value))
    else localStorage.setItem(theKey, value as string)
  }, [key, value])

  return [value as T, setValue]
}
